var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumans({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.687,
    height: 82.297,
    viewBox: "0 0 138.687 82.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-689.157 -1792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_8756475a1208b3c5bed9995a32e7b5c5",
    "data-name": "8756475a1208b3c5bed9995a32e7b5c5",
    transform: "translate(689.157 1811.176)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M63.936,40.575A11.565,11.565,0,0,0,55.1,31.66L33.422,26.892,11.751,31.656A12.634,12.634,0,0,0,2.9,40.585L0,54.424H66.843Z",
    transform: "translate(0 8.697)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M18.777,23.575v6.232c0,4.015,7.273,8.7,7.273,8.7s7.271-4.68,7.271-8.7V23.575H18.777Z",
    transform: "translate(7.371 7.394)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M43.526,19.831c-.716,2.319-2.291,3.962-3.552,3.771s-1.828-2.177-1.227-4.534c.634-2.479,2.3-4.4,3.685-4.167s1.848,2.49,1.095,4.93m-30.308,0c.719,2.319,2.291,3.962,3.552,3.771S18.6,21.426,18,19.068c-.634-2.479-2.3-4.4-3.683-4.167s-1.849,2.49-1.1,4.93",
    transform: "translate(5.049 3.982)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M14.777,9.165a36.242,36.242,0,0,0-.414,5.412c0,12.323,6.008,22.31,13.42,22.31S41.2,26.9,41.2,14.577a36.237,36.237,0,0,0-.416-5.412H14.777Z",
    transform: "translate(5.639 1.737)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M41.784,15.557c0-.1.008-.2.008-.3a13.88,13.88,0,1,0-27.76,0c0,.1.006.2.008.3Z",
    transform: "translate(5.509 -1.336)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M31.527,11.933H25.3a1,1,0,0,1-1-1v-8.6a1,1,0,0,1,1-1h6.226a1,1,0,0,1,1,1v8.6a1,1,0,0,1-1,1m10.76,7.219H14.544a1.8,1.8,0,0,1,0-3.593H42.287a1.8,1.8,0,0,1,0,3.593",
    transform: "translate(5.006 -1.336)",
    fill: "#3360e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M11.716,48.481l4.069-.824a44.82,44.82,0,0,0-3.1-18.027l-4.047.89a44.85,44.85,0,0,1,3.073,17.961m32.554-.824,4.072.827A44.757,44.757,0,0,1,51.416,30.52l-4.047-.89a44.778,44.778,0,0,0-3.1,18.027",
    transform: "translate(3.393 9.771)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M9.568,38.022H49.759V50.055H9.568Z",
    transform: "translate(3.756 13.066)",
    fill: "#dbf6e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_8756475a1208b3c5bed9995a32e7b5c5-2",
    "data-name": "8756475a1208b3c5bed9995a32e7b5c5",
    transform: "translate(761 1811.176)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M63.936,40.575A11.565,11.565,0,0,0,55.1,31.66L33.422,26.892,11.751,31.656A12.634,12.634,0,0,0,2.9,40.585L0,54.424H66.843Z",
    transform: "translate(0 8.697)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    "data-name": "Path 37",
    d: "M18.777,23.575v6.232c0,4.015,7.273,8.7,7.273,8.7s7.271-4.68,7.271-8.7V23.575H18.777Z",
    transform: "translate(7.371 7.394)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-2",
    "data-name": "Path 38",
    d: "M43.526,19.831c-.716,2.319-2.291,3.962-3.552,3.771s-1.828-2.177-1.227-4.534c.634-2.479,2.3-4.4,3.685-4.167s1.848,2.49,1.095,4.93m-30.308,0c.719,2.319,2.291,3.962,3.552,3.771S18.6,21.426,18,19.068c-.634-2.479-2.3-4.4-3.683-4.167s-1.849,2.49-1.1,4.93",
    transform: "translate(5.049 3.982)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2",
    "data-name": "Path 39",
    d: "M14.777,9.165a36.242,36.242,0,0,0-.414,5.412c0,12.323,6.008,22.31,13.42,22.31S41.2,26.9,41.2,14.577a36.237,36.237,0,0,0-.416-5.412H14.777Z",
    transform: "translate(5.639 1.737)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2",
    "data-name": "Path 40",
    d: "M41.784,15.557c0-.1.008-.2.008-.3a13.88,13.88,0,1,0-27.76,0c0,.1.006.2.008.3Z",
    transform: "translate(5.509 -1.336)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2",
    "data-name": "Path 41",
    d: "M31.527,11.933H25.3a1,1,0,0,1-1-1v-8.6a1,1,0,0,1,1-1h6.226a1,1,0,0,1,1,1v8.6a1,1,0,0,1-1,1m10.76,7.219H14.544a1.8,1.8,0,0,1,0-3.593H42.287a1.8,1.8,0,0,1,0,3.593",
    transform: "translate(5.006 -1.336)",
    fill: "#3360e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-2",
    "data-name": "Path 42",
    d: "M11.716,48.481l4.069-.824a44.82,44.82,0,0,0-3.1-18.027l-4.047.89a44.85,44.85,0,0,1,3.073,17.961m32.554-.824,4.072.827A44.757,44.757,0,0,1,51.416,30.52l-4.047-.89a44.778,44.778,0,0,0-3.1,18.027",
    transform: "translate(3.393 9.771)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43-2",
    "data-name": "Path 43",
    d: "M9.568,38.022H49.759V50.055H9.568Z",
    transform: "translate(3.756 13.066)",
    fill: "#dbf6e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_8756475a1208b3c5bed9995a32e7b5c5-3",
    "data-name": "8756475a1208b3c5bed9995a32e7b5c5",
    transform: "translate(717.425 1792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36-3",
    "data-name": "Path 36",
    d: "M83.359,44.732A15.079,15.079,0,0,0,71.844,33.109L43.575,26.892,15.32,33.1C10.082,34.256,4.891,39.5,3.787,44.745L0,62.789H87.15Z",
    transform: "translate(0 19.508)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-3",
    "data-name": "Path 37",
    d: "M18.777,23.575V31.7c0,5.234,9.483,11.337,9.483,11.337s9.479-6.1,9.479-11.337V23.575H18.777Z",
    transform: "translate(15.315 16.803)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-3",
    "data-name": "Path 38",
    d: "M52.842,21.334c-.933,3.023-2.987,5.165-4.632,4.917s-2.384-2.838-1.6-5.912c.826-3.232,3-5.736,4.8-5.432s2.409,3.246,1.427,6.427m-39.515,0c.937,3.023,2.987,5.165,4.632,4.917s2.386-2.838,1.6-5.912c-.826-3.232-3-5.736-4.8-5.432s-2.411,3.246-1.429,6.427",
    transform: "translate(10.489 9.713)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-3",
    "data-name": "Path 39",
    d: "M14.9,9.165a47.252,47.252,0,0,0-.539,7.055c0,16.066,7.833,29.088,17.5,29.088s17.5-13.022,17.5-29.088a47.246,47.246,0,0,0-.543-7.056H14.9Z",
    transform: "translate(11.715 5.049)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-3",
    "data-name": "Path 40",
    d: "M50.215,19.877c0-.134.011-.265.011-.4a18.1,18.1,0,1,0-36.193,0c0,.133.007.263.011.4Z",
    transform: "translate(11.446 -1.336)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-3",
    "data-name": "Path 41",
    d: "M37.23,15.153H29.113a1.307,1.307,0,0,1-1.305-1.305V2.64a1.305,1.305,0,0,1,1.305-1.3H37.23a1.307,1.307,0,0,1,1.305,1.3v11.21a1.305,1.305,0,0,1-1.305,1.3M51.26,24.565H15.089a2.342,2.342,0,0,1,0-4.684H51.26a2.342,2.342,0,0,1,0,4.684",
    transform: "translate(10.401 -1.336)",
    fill: "#3360e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-3",
    "data-name": "Path 42",
    d: "M12.65,54.208l5.305-1.075a58.436,58.436,0,0,0-4.036-23.5L8.643,30.79A58.476,58.476,0,0,1,12.65,54.208m42.444-1.075L60.4,54.212A58.354,58.354,0,0,1,64.41,30.79l-5.276-1.16a58.381,58.381,0,0,0-4.04,23.5",
    transform: "translate(7.049 21.741)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43-3",
    "data-name": "Path 43",
    d: "M9.568,38.022h52.4V53.711H9.568Z",
    transform: "translate(7.804 28.586)",
    fill: "#dbf6e8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumans);
export default __webpack_public_path__ + "static/media/humans.c93e8c27f7017a9e3cedb27105e91eb9.svg";
export { ForwardRef as ReactComponent };